import header from 'i18n/default/es/header';
import mainMenu from 'i18n/default/es/mainMenu';
import pendingPaymentAdvice from 'i18n/default/es/pendingPaymentAdvice';
import PalletType from 'i18n/default/es/PalletType';
import LiteralCurrency from 'i18n/default/es/LiteralCurrency';
import units from 'i18n/default/es/units';
import CustomPalletSize from 'i18n/default/es/CustomPalletSize';
import NumberOfItems from 'i18n/default/es/NumberOfItems';
import LoadInfo from 'i18n/default/es/LoadInfo';
import LoadInputs from 'i18n/default/es/LoadInputs.json';
import dates from 'i18n/default/es/dates';
import Addresses from 'i18n/default/es/Addresses';
import AddressFormModal from 'i18n/default/es/AddressFormModal';
import AddressSelector from 'i18n/default/es/AddressSelector';
import StopAddress from 'i18n/default/es/StopAddress';
import Quote from 'i18n/default/es/Quote';
import extraNames from 'i18n/default/es/extraNames';
import timePickers from 'i18n/default/es/timePickers';
import authLoginForm from 'i18n/default/es/authLoginForm';
import authSignUpForm from 'i18n/default/es/authSignUpForm';
import HandlingExtra from 'i18n/default/es/HandlingExtra';
import Stop from 'i18n/default/es/Stop';
import VehicleExtras from 'i18n/default/es/VehicleExtras';
import OrderStop from 'i18n/default/es/OrderStop';
import ShipmentCard from 'i18n/default/es/ShipmentCard';
import Orders from 'i18n/default/es/Orders';
import Summary from 'i18n/default/es/Summary';
import Login from 'i18n/default/es/Login';
import AddressesPage from 'i18n/default/es/AddressesPage';
import ModalSummary from 'i18n/default/es/ModalSummary';
import OrderSummary from 'i18n/default/es/OrderSummary';
import OrdersOrderDetail from 'i18n/default/es/OrdersOrderDetail';
import Order from 'i18n/default/es/Order';
import ModalOrderDetail from 'i18n/default/es/ModalOrderDetail';
import loads from 'i18n/default/es/loads';
import SuggestedTimes from 'i18n/default/es/SuggestedTimes';
import Downloads from 'i18n/default/es/Downloads';
import CreditCard from 'i18n/default/es/CreditCard';
import TypeOfOrderSelector from 'i18n/default/es/TypeOfOrderSelector';
import Recurring from 'i18n/default/es/Recurring';
import Settings from 'i18n/default/es/Settings';
import InviteUserModal from 'i18n/default/es/InviteUserModal';
import PaymentData from 'i18n/default/es/PaymentData';
import DriverMapError from 'i18n/default/es/DriverMapError';
import Faqs from 'i18n/default/es/Faqs';
import AdditionalDocuments from 'i18n/default/es/AdditionalDocuments';
import Communications from 'i18n/default/es/Communications';
import RecurringOrderSuggestions from 'i18n/default/es/RecurringOrderSuggestions';
import Error from 'i18n/default/es/Error';
import Users from 'i18n/default/es/Users';
import FormTooltips from 'i18n/default/es/FormTooltips.json';
import Tracking from 'i18n/default/es/Tracking.json';
import Dashboard from 'i18n/default/es/Dashboard.json';
import Catalog from 'i18n/default/es/Catalog';
import Emergencies from 'i18n/default/es/Emergencies';
import SignUp from 'i18n/default/es/SignUp';
import Profile from 'i18n/default/es/Profile';
import Landing from 'i18n/default/es/Landing';

const lang = {
  Emergencies,
  Catalog,
  header,
  mainMenu,
  pendingPaymentAdvice,
  PalletType,
  LiteralCurrency,
  units,
  CustomPalletSize,
  NumberOfItems,
  LoadInfo,
  LoadInputs,
  dates,
  AddressFormModal,
  AddressSelector,
  StopAddress,
  Quote,
  extraNames,
  timePickers,
  authLoginForm,
  authSignUpForm,
  SignUp,
  HandlingExtra,
  Stop,
  VehicleExtras,
  OrderStop,
  ShipmentCard,
  Orders,
  Summary,
  Login,
  AddressesPage,
  ModalSummary,
  OrderSummary,
  OrdersOrderDetail,
  Order,
  ModalOrderDetail,
  loads,
  SuggestedTimes,
  Downloads,
  Addresses,
  CreditCard,
  TypeOfOrderSelector,
  Recurring,
  Settings,
  InviteUserModal,
  PaymentData,
  DriverMapError,
  Faqs,
  AdditionalDocuments,
  Communications,
  RecurringOrderSuggestions,
  Error,
  Users,
  FormTooltips,
  Tracking,
  Dashboard,
  Profile,
  Landing
};

export default lang;
